import { Api } from './BaseApi'
import { IFavOrder, IFavorite } from '../../types/Favorites/IFavorite';
import { IFavoriteConfig } from '../../types/Favorites/IFavoriteConfig';

const FavoriteApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getUserFavorites: build.query<IFavorite[], string>({
            query: (uid) => `User/${uid}/Favorite`,
            providesTags: ["GetUserFavs"],
        }),
        saveFavorite: build.mutation<any, { fav: IFavorite, uid: string }>({
            query: (info) => ({
                url: `User/${info.uid}/Favorite`,
                method: "POST",
                body: info.fav
            }),
            invalidatesTags: ["GetUserFavs", "GetContacts"]
        }),
        getFavoriteConfig: build.query<IFavoriteConfig, string>({
            query: (uid) => `User/${uid}/Favorite/Config`,
            providesTags: ["GetFavConfig"],
        }),
        saveFavoriteConfig: build.mutation<any, { config: IFavoriteConfig, uid: string }>({
            query: (info) => ({
                url: `User/${info.uid}/Favorite/Config`,
                method: "POST",
                body: info.config
            }),
            invalidatesTags: ["GetFavConfig", "GetContacts"]
        }),
        sortFavorite: build.mutation<any, { order: IFavOrder, uid: string }>({
            query: (info) => ({
                url: `User/${info.uid}/Favorite/Sort`,
                method: "POST",
                body: info.order
            }),
            invalidatesTags: ["GetUserFavs", "GetContacts"]
        }),
        sortFavCategories: build.mutation<any, { order: string[], uid: string }>({
            query: (info) => ({
                url: `User/${info.uid}/Favorite/Category/Sort`,
                method: "POST",
                body: info.order
            }),
            invalidatesTags: ["GetUserFavs", "GetContacts"]
        }),
        deleteFavorite: build.mutation<any, { favId: number, uid: string }>({
            query: (info) => ({
                url: `User/${info.uid}/Favorite/${info.favId}`,
                method: "DELETE"
            }),
            invalidatesTags: ["GetUserFavs", "GetContacts"]
        }),
        invalidateFavorites: build.mutation<null, void>({
            queryFn: () => ({ data: null }),
            invalidatesTags: ['GetUserFavs'],
        }),
    }),

    overrideExisting: true,
})

export { FavoriteApi };